.badge {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
